import { Controller } from "@hotwired/stimulus";

// Tiny helper used by the responses table. The controller sits on a `<tr>`
// data row whose immediately following sibling is the hidden detail `<tr>`.
// We query the sibling at click time rather than declaring it as a Stimulus
// target — `<tr>` siblings of a controller-bearing `<tr>` are NOT inside the
// controller's scope, so target lookups won't find them.
export default class extends Controller {
  toggle() {
    const detail = this.element.nextElementSibling;
    if (!detail || !detail.classList.contains("jf-response-detail-row")) return;
    if (detail.hasAttribute("hidden")) {
      detail.removeAttribute("hidden");
    } else {
      detail.setAttribute("hidden", "");
    }
  }
}
